<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="shadow border-b border-gray-200  bg-white sm:rounded-lg">
    <div class="w-3/4 m-10 z-10">
      <h1 class="text-2xl font-bold text-gray-900 truncate pt-10 mb-10">
        Find a guide
      </h1>
      <div class="flex flex-col space-y-4">
        <DestinationSelectPicker v-model="search.place" />
        <LanguageSelectPicker v-model="search.language" />
        <FreeSearch v-model="search.search" />
      </div>
    </div>
  </div>

  <div class="pt-10 pb-5">
    <ul
      v-if="guides !== null"
      role="list"
      class="grid grid-cols-1 gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4"
    >
      <li
        v-for="guide in guides.data"
        :key="guide.id"
        class="col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200"
        @click="setGuide(guide) && open"
      >
        <div class="flex-1 flex flex-col p-8">
          <img
            class="w-32 h-32 flex-shrink-0 mx-auto rounded-full"
            :src="
              guide.user.profile_photo_url"
            :alt="guide.user.name"
          >
          <h3 class="mt-6 text-gray-900 text-sm font-medium">
            {{ guide.user.name }}
          </h3>
          <dl class="mt-1 flex-grow flex flex-col justify-between">
            <dt class="sr-only">
              Title
            </dt>
            <dd class="text-gray-500 text-sm">
              {{ guide.team.name }}
            </dd>
            <!--      <dt class="sr-only">
              Role
            </dt>
            <dd class="mt-3">
              <span class="px-2 py-1 text-green-800 text-xs font-medium bg-green-100 rounded-full">    {{ guide.experience }}</span>
            </dd>
          </dl> -->
          </dl>
        </div>
        <div>
          <div class="-mt-px flex divide-x divide-gray-200">
            <div class="w-0 flex-1 flex">
              <a
                class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500"
              >
                <span class="ml-3">Message</span>
              </a>
            </div>
            <div class="-ml-px w-0 flex-1 flex">
              <a
                class="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500"
              >
                <span class="ml-3">Book</span>
              </a>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <div class="">
    <pagination
      v-if="guides !== null"
      :model="guides"
    />
  </div>
  <GuideSliderProfile
    :guide="guide"
    :show="open"
    @close="open = false"
  />
</template>

<script>
import { EnvelopeIcon, PhoneIcon } from '@heroicons/vue/24/solid';
import { ref, onMounted } from 'vue';

import FreeSearch from '../../ComponentsDeprecated/FreeSerach.vue';
import GuideSliderProfile from '../../ComponentsDeprecated/GuideSliderProfile.vue';
import Pagination from '../../ComponentsDeprecated/Pagination.vue';
import '@vuepic/vue-datepicker/dist/main.css';
import DestinationSelectPicker from '@/ComponentsDeprecated/Select/DestinationSelectPicker';
import LanguageSelectPicker from '@/ComponentsDeprecated/Select/LanguageSelectPicker';

export default {
  components: {
    LanguageSelectPicker,
    DestinationSelectPicker,
    FreeSearch,
    GuideSliderProfile,
    Pagination,
    EnvelopeIcon,
    PhoneIcon,
  },
  props: {
    params: {
      required: false,
      default: {},
      type: Object,
    },
    guides: {
      required: false,
    },
  },
  setup() {
    const date = ref();
    onMounted(() => {
      const startDate = new Date();
      const endDate = new Date(new Date().setDate(startDate.getDate() + 7));
      date.value = [startDate, endDate];
    });

    return {
      date,
    };
  },
  data() {
    return {
      guide: null,
      form: this.$inertia.form({
        language_id: null,
      }),
      search: {
        language: this.params.language ?? null,
        place: this.params.place ?? null,
        search: this.params.search ?? null,
        date: this.params.date ?? null,
      },
    };
  },
  computed: {},
  watch: {},
  methods: {
    setGuide(guide) {
      this.open = true;
      this.guide = guide;
    },
  },
};
</script>
